// extracted by mini-css-extract-plugin
export default {"propertiesWrapper":"styles_propertiesWrapper__xS1dw","loadingPage":"styles_loadingPage__3XfN8","isCompares":"styles_isCompares__qnLnO","loader":"styles_loader__0FgGo"};